import React from "react";

const ModalFirmaPie = ({confirmFirma, resetFirma, toggleModal}) => {

    return (
        <div style={{marginTop:"20px"}}>
                    <div className="row">
                        <div className="col-4 alignLeft">
                    <input type="button" className="btn btn-success" value="Confirmar firma" onClick={confirmFirma}></input>
                    </div>
                    <div className="col-4 alignCenter"><input type="button" className="btn btn-secondary" value="Limpiar firma" onClick={resetFirma}></input></div>
                    <div className="col-4 alignRight">
                    <input type="button" className="btn btn-danger" value="No firmar" onClick={toggleModal}></input>
                    </div>
                    </div>
                </div>
    );

}

export default ModalFirmaPie;